"use client";

import { useEffect, useState } from "react";

// Hauteur mesurée du header déconnecté : sert le temps que l'effet mesure la
// vraie valeur, et reste le repli si aucun <header> n'est trouvé.
const FALLBACK_TOP = 82;

/**
 * Sticky calé sous le header fixe du site, quelle que soit sa hauteur réelle.
 *
 * Le header (`components/ui/Header/NewHeader/NewHeader.js`) est en
 * `position: fixed` et sa hauteur varie : plus haut pour un compte connecté
 * (ligne XP/fragments/clés au-dessus de la navigation), sans qu'aucune valeur
 * fixe ne couvre les deux cas. La convention `sticky top-[65px]` utilisée
 * ailleurs sur le site est déjà inexacte hors connexion (82px mesurés) et
 * s'aggrave une fois connecté : le composant se retrouve alors sous le header
 * plutôt qu'en dessous.
 *
 * Mesurer le header en direct est la seule façon de coller à sa vraie hauteur
 * dans tous les cas, plutôt que de deviner une valeur de plus qui casserait à
 * son tour dans un état non testé.
 */
export default function StickyBelowHeader({ children, className = "", gap = 10 }) {
    const [top, setTop] = useState(FALLBACK_TOP);

    useEffect(() => {
        const header = document.querySelector("header");
        if (!header) return;

        const measure = () => setTop(header.getBoundingClientRect().height + gap);
        measure();

        const observer = new ResizeObserver(measure);
        observer.observe(header);
        return () => observer.disconnect();
    }, [gap]);

    return (
        <div className={`sticky ${className}`} style={{ top }}>
            {children}
        </div>
    );
}
